// Centralized blog articles data for listing and navigation
const BLOG_ARTICLES = [
  {
    slug: 'best-gaming-laptops-under-50000',
    title: 'Best Gaming Laptops Under ₹50,000: Performance Meets Affordability (2026 Edition)',
    excerpt: 'Finding a dedicated gaming laptop under ₹50,000 in India is tough, but not impossible. Discover the top brand-new picks for 2026 and how to maximize your budget.',
    author: 'Rahul Verma',
    authorEmoji: '🎮',
    role: 'Gaming & PC Hardware Specialist',
    date: 'May 05, 2026',
    readTime: '12 min read',
    tags: ['Gaming', 'Budget', 'Laptops', 'India', 'Performance', 'RTX'],
    image: 'https://images.unsplash.com/photo-1600861194942-f883de0dfe96?auto=format&fit=crop&w=800&q=80',
  },
  {
    slug: 'laptop-maintenance-simple-habits-for-longevity',
    title: 'Laptop Maintenance: Simple Habits for Longevity - Your Complete Care Guide',
    excerpt: 'Extend your laptop\'s lifespan with 7 proven maintenance habits. From cleaning and cooling to battery care and software hygiene, learn professional techniques.',
    author: 'Dr. Ananya Reddy',
    authorEmoji: '🔧',
    role: 'Computer Hardware Engineer & Maintenance Specialist',
    date: 'Dec 22, 2024',
    readTime: '18 min read',
    tags: ['Maintenance', 'Care Tips', 'Longevity', 'Cleaning', 'Battery Care'],
    image: 'https://images.unsplash.com/photo-1592890288564-76628a30a657?auto=format&fit=crop&w=800&q=80',
  },
  {
    slug: '10-essential-checks-buying-second-hand-laptop',
    title: '10 Essential Checks Before Buying a Second-Hand Laptop: Your Complete Checklist',
    excerpt: 'Avoid costly mistakes when buying used laptops. This comprehensive checklist covers 10 essential checks that will help you identify genuine bargains and avoid hidden problems.',
    author: 'Vikram Singh',
    authorEmoji: '🔍',
    role: 'Hardware Diagnostic Expert & Quality Assurance Specialist',
    date: 'Dec 20, 2024',
    readTime: '15 min read',
    tags: ['Checklist', 'Second Hand', 'Quality Check', 'Buying Guide', 'Hardware'],
    image: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?auto=format&fit=crop&w=800&q=80',
  },
  {
    slug: 'top-7-benefits-refurbished-laptops-india',
    title: 'Top 7 Benefits of Buying Refurbished Laptops in India for Students & Professionals',
    excerpt: 'Discover why refurbished laptops are the smart choice for Indian students and professionals. From massive cost savings to premium brand access.',
    author: 'Priya Sharma',
    authorEmoji: '🎓',
    role: 'Education Technology Specialist',
    date: 'Dec 18, 2024',
    readTime: '12 min read',
    tags: ['Students', 'Professionals', 'Budget', 'Refurbished', 'India'],
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80',
  },
  {
    slug: 'refurbished-vs-new',
    title: 'Refurbished vs Brand New: Which Laptop is the Right Investment?',
    excerpt: 'Making the smart choice between refurbished and brand new laptops requires understanding value, performance, and long-term benefits.',
    author: 'Arjun Sharma',
    authorEmoji: '👨‍💻',
    role: 'Senior Tech Expert',
    date: 'Dec 15, 2024',
    readTime: '8 min read',
    tags: ['Laptops', 'Investment', 'Refurbished'],
    image: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?auto=format&fit=crop&w=800&q=80',
  },
  {
    slug: 'wfh-setup-guide',
    title: 'Ultimate Work From Home Laptop Setup Guide for Maximum Productivity',
    excerpt: 'Transform your home workspace with the perfect laptop setup. Essential tips for ergonomics, productivity tools, and creating an efficient work environment.',
    author: 'Naseer Ahmed',
    authorEmoji: '🏠',
    role: 'Remote Work Expert',
    date: 'Dec 8, 2024',
    readTime: '12 min read',
    tags: ['Work From Home', 'Productivity', 'Setup'],
    image: 'https://images.unsplash.com/photo-1593062096033-9a26b09da705?auto=format&fit=crop&w=800&q=80',
  },
  {
    slug: 'i3-vs-i5-vs-i7',
    title: 'i3 vs i5 vs i7 Processors: Which Upgrade Matters Most?',
    excerpt: 'Demystify Intel processor differences with practical buying advice for students, professionals, and budget-conscious buyers.',
    author: 'Rohit Mehta',
    authorEmoji: '⚡',
    role: 'Processor Architecture Expert',
    date: 'Dec 25, 2024',
    readTime: '14 min read',
    tags: ['Processors', 'CPU Comparison', 'Performance'],
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80',
  },
];

export default BLOG_ARTICLES;
